import {
  Button,
  Box,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  ButtonGroup,
  VStack,
  useMediaQuery,
} from '@chakra-ui/react';
import moment from 'moment';
import React, { useMemo } from 'react';
import { ChevronDownIcon } from '@chakra-ui/icons';

interface MonthPickerProps {
  selectedMonth: number;
  handleSelectedMonth: (MONTH: number) => void;
  START_MONTH: number;
}

export const MonthPicker = (props: MonthPickerProps): JSX.Element => {
  const { START_MONTH, selectedMonth, handleSelectedMonth } = props;

  const [isLagerThan1024] = useMediaQuery('(min-width: 1024px)');
  const [isSmallerThan1024] = useMediaQuery('(max-width: 1024px)');
  const [isTabletOrMobile] = useMediaQuery('(max-width: 767px)');

  const months = useMemo(() => {
    return moment
      .localeData('de')
      .monthsShort()
      .map((month, i) => ({ name: month, id: i }));
  }, []);

  const selectedMonthName = useMemo(() => {
    const showedMonth = months.find(month => month.id === selectedMonth);
    return showedMonth?.name;
  }, [months, selectedMonth]);

  return (
    <>
      {!isTabletOrMobile && isLagerThan1024 && (
        <ButtonGroup spacing={0} variant="outline" colorScheme={'blue'}>
          {months.map((month, idx) => {
            return (
              <Button
                bg={month.id === selectedMonth ? 'blue.500' : 'inherit'}
                textColor={month.id === selectedMonth ? 'white' : 'blue.500'}
                borderWidth={month.id === selectedMonth ? 0 : 1}
                _hover={{ bg: month.id === selectedMonth ? 'blue.400' : 'blue.100' }}
                borderLeft={idx === 0 ? '1px solid' : 'none'}
                borderTopRightRadius={months.length - 1 === idx ? 4 : 0}
                borderTopLeftRadius={idx === 0 ? 4 : 0}
                borderBottomRightRadius={months.length - 1 === idx ? 4 : 0}
                borderBottomLeftRadius={idx === 0 ? 4 : 0}
                key={month.id}
                onClick={() => handleSelectedMonth(month.id)}>
                {month.name}
              </Button>
            );
          })}
        </ButtonGroup>
      )}

      {!isTabletOrMobile && isSmallerThan1024 && (
        <VStack alignItems={'flex-start'}>
          <ButtonGroup spacing={0} variant="outline" colorScheme={'blue'}>
            {months.slice(0, 6).map((month, idx) => {
              return (
                <Button
                  bg={month.id === selectedMonth ? 'blue.500' : 'inherit'}
                  textColor={month.id === selectedMonth ? 'white' : 'blue.500'}
                  borderWidth={month.id === selectedMonth ? 0 : 1}
                  _hover={{ bg: month.id === selectedMonth ? 'blue.400' : 'blue.100' }}
                  borderLeft={idx === 0 ? '1px solid' : 'none'}
                  borderTopRightRadius={months.slice(0, 6).length - 1 === idx ? 4 : 0}
                  borderTopLeftRadius={idx === 0 ? 4 : 0}
                  borderBottomRightRadius={months.slice(0, 6).length - 1 === idx ? 4 : 0}
                  borderBottomLeftRadius={idx === 0 ? 4 : 0}
                  key={month.id}
                  onClick={() => handleSelectedMonth(month.id)}>
                  {month.name}
                </Button>
              );
            })}
          </ButtonGroup>
          <ButtonGroup spacing={0} variant="outline" colorScheme={'blue'}>
            {months.slice(6, 12).map((month, idx) => {
              return (
                <Button
                  bg={month.id === selectedMonth ? 'blue.500' : 'inherit'}
                  textColor={month.id === selectedMonth ? 'white' : 'blue.500'}
                  borderWidth={month.id === selectedMonth ? 0 : 1}
                  _hover={{ bg: month.id === selectedMonth ? 'blue.400' : 'blue.100' }}
                  borderLeft={idx === 0 ? '1px solid' : 'none'}
                  borderTopRightRadius={months.slice(6, 12).length - 1 === idx ? 4 : 0}
                  borderTopLeftRadius={idx === 0 ? 4 : 0}
                  borderBottomRightRadius={months.slice(6, 12).length - 1 === idx ? 4 : 0}
                  borderBottomLeftRadius={idx === 0 ? 4 : 0}
                  key={month.id}
                  onClick={() => handleSelectedMonth(month.id)}>
                  {month.name}
                </Button>
              );
            })}
          </ButtonGroup>
        </VStack>
      )}
      {isTabletOrMobile && (
        <Box flex={1} width={'100%'}>
          <Menu matchWidth={true}>
            <MenuButton
              fontWeight={'normal'}
              variant={'outline'}
              as={Button}
              rightIcon={<ChevronDownIcon />}
              w={'100%'}>
              {selectedMonthName}
            </MenuButton>
            <MenuList zIndex={15}>
              {months.map(month => {
                return (
                  <MenuItem key={month.id} onClick={() => handleSelectedMonth(month.id)}>
                    {month.name}
                  </MenuItem>
                );
              })}
            </MenuList>
          </Menu>
        </Box>
      )}
    </>
  );
};
